module.exports = new Promise((resolve) => {
    const script = document.createElement('script');
    let settled = false;
    const fail = (message) => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      console.warn(message);
      resolve({
        get: () => Promise.reject(new Error(message)),
        init: () => undefined
      });
    };
    script.src = 'https://app.bellwetherit.com/assets/endpoint-state/remoteEntry.js';
    script.onload = () => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      resolve({
        get: (request) => window['endpointStateRemote']
          ? window['endpointStateRemote'].get(request)
          : Promise.reject(new Error('Module endpointStateRemote not available')),
        init: (shareScope) => {
          try {
            return window['endpointStateRemote'] ? window['endpointStateRemote'].init(shareScope) : undefined;
          } catch (error) {
            console.warn('endpointStateRemote init failed:', error);
            return undefined;
          }
        }
      });
    };
    script.onerror = () => fail('Failed to load remote: endpointStateRemote');
    const deadline = setTimeout(() => fail('Timed out loading remote: endpointStateRemote'), 10000);
    document.head.appendChild(script);
  });